@if (isLoading()) {
  <div class="loading" [class]="cssClass()" [style.width]=""></div>
}

@if (!isLoading()) {
  <ng-container *ngTemplateOutlet="templateRef()" />
}
